// Admin configuration for Tag-Inn platform owner
export const ADMIN_EMAIL = 'taginnovation1@gmail.com';

export const isAdmin = (email: string | undefined | null): boolean => {
  return email === ADMIN_EMAIL;
};
